/**
 * Action for Fetch Service Event
 */
export enum fetchServiceEventSchema {
  FETCH_SERVICE_EVENT_SCHEMA_REQUEST = 'FETCH_SERVICE_EVENT_SCHEMA_REQUEST'
}
